import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { importItems } from "../../api/masterItems";

// استيراد المواد من Excel/CSV: يقبل أعمدة عربية أو إنجليزية ويعرض تقرير الصفوف المرفوضة.
export const ItemImport = ({ onDone, branchId }) => {
  const { t } = useTranslation();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!branchId) { toast.error(t("purchases.items.pickBranchFirst")); event.target.value = ""; return; }
    setBusy(true);
    try {
      const result = await importItems(branchId, file);
      toast.success(t("purchases.items.imported", { count: result.created }));
      if (result.errors?.length) {
        toast.error(t("purchases.items.importErrors", { count: result.errors.length }));
      }
      onDone?.();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    } finally {
      setBusy(false);
      event.target.value = "";
    }
  };

  return (
    <>
      <input ref={input} type="file" accept=".xlsx,.xlsm,.csv" className="hidden"
             data-testid="item-import-input" onChange={pick} />
      <NeuButton className="flex items-center gap-2 px-4 py-3 text-xs" disabled={busy || !branchId}
                 data-testid="item-import-btn" onClick={() => input.current?.click()}>
        <Upload className="h-4 w-4" /> {t("purchases.items.importExcel")}
      </NeuButton>
    </>
  );
};
